/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { closest } from '@/js/utils/css'
import { dataAsBool, findOne } from '@/js/utils/dom'

/**
 * Submit a target form after writing a `data-form-toggle-value` into a
 * `data-form-toggle-field` field.
 *
 * @type {Listener}
 */
export default {
    selector: '.form-toggle',
    connect(element) {
        const onClick = () => {
            const field = findOne(`#${element.dataset.formToggleField}`)
            if (!field) {
                return
            }

            const form = closest(field, 'form')
            if (!form) {
                return
            }

            if (field.type === 'checkbox') {
                field.checked = dataAsBool(element, 'formToggleValue')
            } else {
                field.value = element.dataset.formToggleValue
            }

            form.requestSubmit()
        }

        element.addEventListener('click', onClick)

        return () => element.removeEventListener('click', onClick)
    },
}
